import {
    initializeApp,
    FirebaseApp,
} from 'firebase/app'
import { getAnalytics } from 'firebase/analytics'

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

/**
 * Firebase app singleton initialized once on module load
 */
export const firebaseApp: FirebaseApp = initializeApp(firebaseConfig)

if (import.meta.env.PROD && firebaseConfig.measurementId) {
    try {
        getAnalytics(firebaseApp)
    } catch (err) {
        console.warn('Firebase analytics init failed:', err)
    }
}

/**
 * Whether to wire the SDKs (Auth, Firestore, Functions) to the local Firebase emulator
 * suite. Enabled in local dev (`vite`) only — guarded by `import.meta.env.DEV` so a
 * production build NEVER connects to an emulator. Run `firebase emulators:start` alongside
 * `npm run dev` so the emulators (auth:9099, firestore:8080, functions:5001) are reachable.
 *
 * @return {boolean}
 */
export const useFirebaseEmulator = (): boolean =>
    Boolean(import.meta.env.DEV)

/**
 * Host serving the emulator suite. Defaults to the page host so the app works whether
 * opened via localhost or the machine's LAN IP.
 *
 * @return {string}
 */
export const emulatorHost = (): string =>
    import.meta.env.VITE_EMULATOR_HOST || window.location.hostname

/**
 * Base URL for HTTP (onRequest) Cloud Functions. In emulator/dev mode it targets the
 * local Functions emulator; otherwise the deployed europe-west3 endpoint.
 *
 * @return {string}
 */
export const functionsBaseUrl = (): string =>
    useFirebaseEmulator()
        ? `http://${emulatorHost()}:5001/topgain-monitoring/europe-west3`
        : 'https://europe-west3-topgain-monitoring.cloudfunctions.net'

/**
 * Backward-compatible initializer. Returns the singleton app instance.
 *
 * @return {FirebaseApp}
 */
export const initFirebase = (): FirebaseApp => firebaseApp
